import { render, staticRenderFns } from "./CFormProject_STI.vue?vue&type=template&id=97568eea&scoped=true&"
import script from "./CFormProject_STI.vue?vue&type=script&lang=js&"
export * from "./CFormProject_STI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97568eea",
  null
  
)

export default component.exports